const LoadingPage = () => {
  return (
    <div className="w-full h-full flex flex-col justify-center items-center">
      <div className="loading loading-spinner h-24 w-24 text-primary" />
    </div>
  );
};

export default LoadingPage;
